export { default } from './SWStandardCard';
